export const MU_NAME_TO_BASE_NUM_REGEXP =
  /(ВОЙСК.*\s+ЧАСТ.*|в\/ч)\s+№?(\d{4,5}\s?[\s{1}-]\s?[а-яА-Я]$|\d{4,5}\s?[\s{1}-]\s?"[а-яА-Я]"$|\d{4,5}[\s{1}-]\d+|\d{4,5}[\s{1}-]"\d+"|\d{4,5})/
